<p-dialog [(visible)]="visible"
          (visibleChange)="visibleChange.emit($event)"
          [modal]="true"
          [style]="{width: '600px', maxHeight: '90vh'}"
          [draggable]="false"
          [resizable]="false"
          [closable]="true"
          [contentStyle]="{'max-height': '70vh', 'overflow-y': 'auto'}"
          (onHide)="closeModal()"> 
    <ng-template pTemplate="header">
        <div class="text-lg font-semibold text-900">Edit Vehicle</div>
    </ng-template>
    
    <div class="flex mb-4" style="border-bottom: 2px solid #E5E7EB;">
        <div class="cursor-pointer px-4 py-2" 
             [ngClass]="{'border-bottom-active': activeTab === 'details'}"
             (click)="switchTab('details')"
             style="font-weight: 500; color: #111827;">
            Vehicle Details
        </div>
        <div class="cursor-pointer px-4 py-2 ml-3" 
             [ngClass]="{'border-bottom-active': activeTab === 'photos'}"
             (click)="switchTab('photos')"
             style="font-weight: 500; color: #111827;">
            Vehicle Photos
        </div>
    </div>
    
    <div *ngIf="activeTab === 'details'" class="mt-3 pr-2">
        <div class="flex flex-column mb-3">
            <label class="text-sm text-600 font-medium mb-2">Vehicle Type</label>
            <p-dropdown *ngIf="canEditVehicleType"
                        [options]="sedanSuvOptions"
                        [(ngModel)]="selectedVehicleTypeObj"
                        optionLabel="name"
                        [editable]="false"
                        placeholder="Select vehicle type"></p-dropdown>
            <input *ngIf="!canEditVehicleType"
                   pInputText
                   type="text"
                   [value]="selectedVehicleTypeObj?.name || ''"
                   [disabled]="true"
                   readonly />
        </div>
        
        <div class="flex flex-column mb-3">
            <label class="text-sm text-600 font-medium mb-2">Vehicle Make</label>
            <p-dropdown [options]="vehicleBrands" 
                        [(ngModel)]="selectedBrandObj"
                        optionLabel="NameBrand"
                        [editable]="false"
                        [filter]="true"
                        filterBy="NameBrand"
                        (onChange)="onBrandDropdownChange($event)"
                        placeholder="Select brand"
                        [showClear]="true"></p-dropdown>
        </div>
        
        <div class="flex flex-column mb-3">
            <label class="text-sm text-600 font-medium mb-2">Vehicle Model</label>
            <p-dropdown [options]="vehicleModels" 
                        [(ngModel)]="selectedModelObj"
                        optionLabel="NameModel"
                        [editable]="true"
                        [filter]="false"
                        (onChange)="onModelDropdownChange($event)"
                        placeholder="Select or type model"
                        [showClear]="true"></p-dropdown>
        </div>
        
        <div class="flex gap-3 mb-3">
            <div class="flex flex-column flex-1">
                <label class="text-sm text-600 font-medium mb-2">Plate Number</label>
                <input pInputText type="text" [(ngModel)]="editVehicle.NumberPlate" placeholder="ABC 1234" />
            </div>
            
            <div class="flex flex-column flex-1">
                <label class="text-sm text-600 font-medium mb-2">Vehicle Year</label>
                <p-dropdown [options]="yearOptions" 
                            [(ngModel)]="editVehicle.VehicleYear"
                            placeholder="Select Year"
                            [showClear]="false"
                            [filter]="true"></p-dropdown>
            </div>
        </div>
        
        <div class="flex flex-column mb-3">
            <label class="text-sm text-600 font-medium mb-2">Vehicle Color (free text)</label>
            <input pInputText type="text" [(ngModel)]="editVehicle.VehicleColorText" placeholder="White" />
        </div>
        
        <div class="flex flex-column mb-3">
            <label class="text-sm text-600 font-medium mb-2">Registration Number</label>
            <input pInputText type="text" [(ngModel)]="editVehicle.RegistrationNumber" placeholder="0923924733" />
        </div>
        
        <div class="flex flex-column mb-3">
            <label class="text-sm text-600 font-medium mb-2">Case No. (optional)</label>
            <input pInputText type="text" [(ngModel)]="editVehicle.PaOrCpcCaseNumber" placeholder="e.g., CASE-2026-00123" />
        </div>
    </div>
    
    <div *ngIf="activeTab === 'photos'" class="mt-3 pr-2">
        <div class="text-base font-semibold text-900 mb-3">Vehicle Image</div>
        
        <div class="grid">
            <div class="col-6">
                <label class="text-sm text-600 font-medium mb-2 block">Front view</label>
                <div class="border-2 border-dashed surface-border border-round p-3 text-center flex align-items-center justify-content-center"
                     style="min-height: 150px;">
                    <div *ngIf="!editVehicle.VehicleFrontImageUrl" class="text-center text-sm text-600">No photo available</div>
                    <img *ngIf="editVehicle.VehicleFrontImageUrl" [src]="editVehicle.VehicleFrontImageUrl"
                         class="w-full" style="max-height: 140px; object-fit: contain;" />
                </div>
            </div>
            
            <div class="col-6">
                <label class="text-sm text-600 font-medium mb-2 block">Back View</label>
                <div class="border-2 border-dashed surface-border border-round p-3 text-center flex align-items-center justify-content-center"
                     style="min-height: 150px;">
                    <div *ngIf="!editVehicle.VehicleBackImageUrl" class="text-center text-sm text-600">No photo available</div>
                    <img *ngIf="editVehicle.VehicleBackImageUrl" [src]="editVehicle.VehicleBackImageUrl"
                         class="w-full" style="max-height: 140px; object-fit: contain;" />
                </div>
            </div>
            
            <div class="col-6">
                <label class="text-sm text-600 font-medium mb-2 block">Left Side View</label>
                <div class="border-2 border-dashed surface-border border-round p-3 text-center flex align-items-center justify-content-center"
                     style="min-height: 150px;">
                    <div *ngIf="!editVehicle.VehicleLeftSideImageUrl" class="text-center text-sm text-600">No photo available</div>
                    <img *ngIf="editVehicle.VehicleLeftSideImageUrl" [src]="editVehicle.VehicleLeftSideImageUrl"
                         class="w-full" style="max-height: 140px; object-fit: contain;" />
                </div>
            </div>
            
            <div class="col-6">
                <label class="text-sm text-600 font-medium mb-2 block">Right Side View</label>
                <div class="border-2 border-dashed surface-border border-round p-3 text-center flex align-items-center justify-content-center"
                     style="min-height: 150px;">
                    <div *ngIf="!editVehicle.VehicleRightSideImageUrl" class="text-center text-sm text-600">No photo available</div>
                    <img *ngIf="editVehicle.VehicleRightSideImageUrl" [src]="editVehicle.VehicleRightSideImageUrl"
                         class="w-full" style="max-height: 140px; object-fit: contain;" />
                </div>
            </div>
        </div>
    </div>
    
    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">
            <button pButton type="button" label="Discard Changes" severity="secondary" [disabled]="isVehicleSaving" (click)="resetForm()"></button>
            <button pButton type="button" label="Update" severity="info" [disabled]="isVehicleSaving" (click)="saveVehicle()"></button>
        </div>
    </ng-template>
</p-dialog>
